import { useIsAuthenticated } from "@refinedev/core";
import { Navigate } from "react-router";
import { ProtectedLayout } from "../layout/ProtectedLayout";
import { AsyncState } from "../ui/async-state";

export function ProtectedBoundary() {
  const { data, isLoading } = useIsAuthenticated();

  if (isLoading) {
    return (
      <main className="grid min-h-svh place-items-center p-6">
        <AsyncState
          kind="loading"
          title="Checking staff session"
          message="Validating the current session."
        />
      </main>
    );
  }

  if (!data?.authenticated) return <Navigate to="/login" replace />;
  return <ProtectedLayout />;
}
